import { QUERYBUILDER } from '../../../container';
import { createExportProvider } from '../../app';

export function configureExportProvider() {
    return createExportProvider({
        querybuilder: QUERYBUILDER,
    });
}
